/*================================================================================================================
*                                            Users & Rights
* ==============================================================================================================*/

// users
export const GET_USER_BY_UID_KEY = 'userUid';
export const GET_USERS_KEY = 'users';
export const UPSERT_USER_KEY = 'upsertUser';
export const DELETE_USER_KEY = 'deleteUser';
export const LINK_USER_GOOGLE_ACCOUNT = 'linkUserGoogleAccount';
export const UNLINK_USER_GOOGLE_ACCOUNT = 'unlinkUserGoogleAccount';
export const LOGOUT_USERS_KEY = 'logoutUsers'

/*================================================================================================================
*                                            Borehole
* ==============================================================================================================*/

// Master Data
export const GET_GROUND_WATER_ZONES_KEY = 'groundWaterZones';
export const UPSERT_GROUND_WATER_ZONE_KEY = 'upsertGroundWaterZone';
export const DELETE_GROUND_WATER_ZONE_KEY = 'deleteGroundWaterZone';


export const GET_DAM_CONSTRUCTION_TYPES_KEY = 'damConstructionTypes';
export const UPSERT_DAM_CONSTRUCTION_TYPE_KEY = 'upsertDamConstructionType';
export const DELETE_DAM_CONSTRUCTION_TYPE_KEY = 'deleteDamConstructionType';


/*================================================================================================================
*                                                Dev Tools
* ==============================================================================================================*/

// logging
export const GET_LOGS_KEY = 'logs';

// sync status
export const GET_SYNC_STATUS_KEY = 'syncStatus';
export const SET_SYNC_STATUS_KEY = 'setSyncStatus';
export const TRIGGER_FULL_SYNC_KEY = 'triggerFullSync';